import { Flex, IconCheck } from '@vtex/admin-ui'
import styles from './styles.css'

export const SelectedItem = ({ name }) => (
  <Flex className={styles.full}>
    <span className={styles.label}>{name}</span>
    <IconCheck className={styles.icon} />
  </Flex>
)
